import fly from './fly';
import { getAuth } from '@/util/storage';
const auth = getAuth();

//报修类型列表
export const fetchType = () => fly.get('/baseUseMallKey/repair-api/front/type', { auth });
//提交工单
export const submitRepairApi = (params: any) => fly.post('/baseUseMallKey/repair-api/order', { ...params, auth });
//工单列表
export const ticketListApi = (params: any) => fly.get('/baseUseMallKey/repair-api/order', { auth, ...params });
//取消工单
export const cancelTicketApi = (params: any) => fly.get('/baseUseMallKey/repair-api/order/cancel', { auth, ...params });
//工单详情
export const ticketDetailApi = (params: any) => fly.get('/baseUseMallKey/repair-api/order/detail', { auth, ...params });
//查看工单进度
export const ticketlogApi = (params: any) => fly.get('/baseUseMallKey/repair-api/order/log', { auth, ...params });
//提交评价
export const ticketCommentApi = (params: any) =>
	fly.post('/baseUseMallKey/repair-api/order/comment', { auth, ...params });
//再次提交工单
export const ticketAgainApi = (params: any) => fly.post('/baseUseMallKey/repair-api/order/again', { auth, ...params });
